<template lang="pug">
  div
    multiselect(
      class="main-multiselect multiselect-autocomplete"
      :hide-selected="true"
      :options="options"
      label="text"
      track-by="id"
      group-values="values"
      group-label="label"
      :clear-on-select="false"
      :group-select="false"
      :internal-search="false"
      :close-on-select="false"
      :placeholder="placeholder"
      select-label=""
      open-direction="top"
      @search-change="asyncFind"
      @select="addLocation"
    )
      p.multiselect__option.bg-white.w-full.shadow-none(slot="noResult") Aucun résultat
      p.multiselect__option.bg-white.w-full.shadow-none(slot="noOptions") Veuillez choisir une ville

    vue-tags-input(
      v-model="tag"
      :tags="selectedLocations"
      @tags-changed="removeLocation"
    )
</template>

<script>
import axios from 'axios'
import { debounce } from 'lodash'
import Multiselect from 'vue-multiselect'
import VueTagsInput from '@johmun/vue-tags-input'
import { formatLocations } from "@utils/locations-helpers"

export default {
  components: {
    Multiselect,
    VueTagsInput
  },

  props: {
    cities: {
      type: Array,
      default: () => {
        return []
      }
    },

    sectors: {
      type: Array,
      default: () => {
        return []
      }
    },

    searchParams: {
      type: Object,
      required: true
    },

    placeholder: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      tag: '',
      options: [],
      label: 'Villes'
    }
  },

  computed: {
    selectedCities () {
      return this.selectedLocations.filter(location => location.type === 'City')
    },

    selectedSectors () {
      return this.selectedLocations.filter(location => location.type === 'Sector')
    },

    selectedCityIds () {
      return this.selectedCities.map(c => c.id)
    },

    selectedSectorIds () {
      return this.selectedSectors.map(c => c.id)
    },

    selectedLocations () {
      const cities = this.cities
      const sectors = this.sectors

      return [
        ...cities,
        ...sectors
      ]
    }
  },

  methods: {
    addLocation (location) {
      this.$emit('location-added', location)
    },

    removeLocation (tags) {
      // Find the one that's been removed from tags
      const location = this.selectedLocations.find(l => {
        return !tags.find(t => t.type === l.type && t.id === l.id)
      })

      this.$emit('location-removed', location)
    },

    asyncFind (query) {
      this.search(query, this)
    },

    search: debounce((query, vm) => {
      axios.get('/api/v1/locations', {
        params: {
          query
        }
      })
        .then(({ data }) => {
          vm.options = formatLocations(data)
        })
    }, 350)
  }
}
</script>
